import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class SalesOfferModel extends Model {
  static reducer(action, SalesOfferModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.SalesOffer.schema:
        action.payload.forEach((payload) => {
          const dbData = SalesOfferModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          SalesOfferModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
SalesOfferModel.modelName = "SalesOfferModel";

SalesOfferModel.fields = {
  id: attr(),
};

export default SalesOfferModel;